import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "../../../shared/components/sheet/Sheet";
import HomeLink from "../HomeLink";
import NavigationLink from "../NavigationLink";
import MobileMenuTrigger from "./MobileMenuTrigger";

const MobileNavigationMenu = ({ sections, selectedIndex, onItemClick }) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <MobileMenuTrigger />
      </SheetTrigger>
      <SheetContent side="left">
        <nav className="grid gap-6 text-lg font-medium">
          <HomeLink />
          {sections?.map((item, index) => (
            <NavigationLink
              key={`sheet_item_${item.code}`}
              item={item}
              index={index}
              isSelected={selectedIndex === index}
              onItemClick={onItemClick}
            />
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export default MobileNavigationMenu;
